export const endpoints = {
  globalSearch: sellerSlug => `/sellers/${sellerSlug}/global-search/`,
};
